import appGlobalScript from '/agent/_work/1/s/onekey-sdk-web-lib/packages/hcl-sdk-web-ui/src/global/app.ts';
export const globalScripts = appGlobalScript;
